/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_AccountInputs */

const cs_social_export_account = /** @type {(inputs: Social_Export_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikovat z`)
};

const en_social_export_account = /** @type {(inputs: Social_Export_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish from`)
};

/**
* | output |
* | --- |
* | "Publish from" |
*
* @param {Social_Export_AccountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_account = /** @type {((inputs?: Social_Export_AccountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_AccountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_account(inputs)
	return cs_social_export_account(inputs)
});